export default __webpack_public_path__ + "static/media/icon-facebook.d995ecfd.svg";